$narrow: 760px;

.sessions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.session {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  padding: 24px 22px;
  border: 1px solid var(--qs-color-line);
  border-radius: var(--qs-radius-lg);
  background: var(--qs-color-surface);
}

.language {
  font-size: var(--qs-type-caption-size);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--qs-color-accent);
}

.writtenFor {
  margin: 0;
  text-align: center;
  font-size: var(--qs-type-small-size);
  line-height: var(--qs-type-small-lh);
  color: var(--qs-color-text-soft);
}

.player {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.length {
  font-size: var(--qs-type-small-size);
  color: var(--qs-color-text-muted);
}

.transcript {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid var(--qs-color-line);
  font-size: var(--qs-type-small-size);
  line-height: var(--qs-type-reading-lh);
  color: var(--qs-color-text-soft);

  h4 {
    font-family: var(--qs-font-text);
    font-style: normal;
    font-size: var(--qs-type-caption-size);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--qs-color-text-muted);
  }

  p { margin: 0; }
  summary { cursor: pointer; color: var(--qs-color-accent); }
  details p { margin-top: 10px; }
}

.walkthrough { max-width: 560px; }

@media (max-width: $narrow) {
  .session { padding: 20px 16px; }
}
